import React, { useEffect, useRef } from "react";
import { Table } from "antd";
import DataGrid from "components/DataGrid";

const defaultScroll = { y: "calc(100vh - 270px)" };

const EntityGrid = (props) => {
  const {
    className,
    grid,
    fetchData,
    fetchDataPending,
    data,
    columns,
    resetGridData,
    GridTitle,
    setGridParams,
    isAutoRefresh = false,
    refreshIntervalInMS = 30000,
    expandedRowRender,
    rowKey,

    toolbarComponent,

    rowSelection,
    size,
    scroll = defaultScroll,
    // optional antd pagination props merged over the Redux grid pagination (e.g. showTotal);
    // kept out of the store because functions are not serializable
    paginationExtra,
  } = props;

  const lastFetchedParamsRef = useRef(null);

  useEffect(() => {
    const fetchParams = {
      filters: grid.params.filters,
      current: grid.params.pagination?.current,
      pageSize: grid.params.pagination?.pageSize ?? grid.params.pagination?.limit,
      search: grid.params.search,
      sorter: grid.params.sorter,
    };
    const serialized = JSON.stringify({
      filters: fetchParams.filters,
      current: fetchParams.current,
      pageSize: fetchParams.pageSize,
      search: fetchParams.search,
      sorter: fetchParams.sorter,
    });
    if (lastFetchedParamsRef.current === serialized) {
      return;
    }
    lastFetchedParamsRef.current = serialized;
    loadData(grid, fetchData);
  }, [
    grid.params.sorter,
    grid.params.filters,
    grid.params.pagination?.current,
    grid.params.pagination?.pageSize ?? grid.params.pagination?.limit,
    grid.params.search,
  ]);

  useEffect(() => {
    if (isAutoRefresh) {
      const interval = setInterval(() => {
        loadData(grid, fetchData);
      }, refreshIntervalInMS);
      return () => clearInterval(interval);
    }
  });

  //componentWillUnmount
  useEffect(
    () => () => {
      resetGridData();
    },
    []
  );

  const handleTableChange = (pagination, filters, sorter) => {
    setGridParams({ ...grid.params, pagination, sorter });
  };

  return (
    <DataGrid
      className={className}
      toolbarComponent={toolbarComponent}
      isLoading={fetchDataPending}
      data={data}
      onChange={handleTableChange}
      scroll={scroll}
      rowSelection={rowSelection}
      size={size}
      GridTitle={GridTitle}
      expandedRowRender={expandedRowRender}
      rowKey={rowKey}
      pagination={paginationExtra ? { ...grid.params.pagination, ...paginationExtra } : grid.params.pagination}
    >
      {columns.map((column, i) => {
        return <Table.Column {...column} />;
      })}
    </DataGrid>
  );
};

EntityGrid.propTypes = {
  // gridId: PropTypes.string.isRequired,
};

export const loadData = (grid, fetchData) => {
  // in the grid params filters map, we take each value (which is an array) and transform it into a joined string
  const filters = Object.keys(grid.params.filters).reduce(
    (accumulator, currentKey) => {
      const currentValue = grid.params.filters[currentKey];

      accumulator[currentKey] = Array.isArray(currentValue)
        ? currentValue.join()
        : currentValue;

      return accumulator;
    },
    {}
  );
  const params = {
    ...grid.params,
    filters,
  };

  fetchData(params);
};

export default React.memo(EntityGrid);
